import type { ProductCatalogIndexItem } from "@/catalog";

export function itemsForCountry(
  items: ProductCatalogIndexItem[],
  country: string,
): ProductCatalogIndexItem[] {
  return country === "all"
    ? items
    : items.filter((item) => item.countryCodes?.includes(country));
}
